import type { TransactionFlow, TransactionType } from '@/types/models';

export const transactionFlowEnum: Record<
    'INWARD' | 'OUTWARD',
    TransactionFlow
> = {
    INWARD: 1,
    OUTWARD: 2,
};

const transactionTypeEnumMap = {
    SALES: 1,
    BILL_PAYMENT: 2,
    TRANSFER_IN: 3,
    TRANSFER_OUT: 4,
    COLLECTION: 5,
} as const;

export type TransactionTypeKeys = keyof typeof transactionTypeEnumMap;
export type TransactionTypeValues =
    (typeof transactionTypeEnumMap)[TransactionTypeKeys];

export const transactionTypeEnum: TransactionType extends TransactionTypeValues
    ? typeof transactionTypeEnumMap
    : never = transactionTypeEnumMap;
